import { Refresh } from '@mui/icons-material';
import { IconButton, Button as MuiButton, Stack } from '@mui/material';
import { Button, Dropdown, } from 'react-bootstrap';
import { TableRefreshButton } from './CustomButtons';

export const SecondaryTabsTestCases = ({
  handleOpenTestCaseModal,
  isSelectedItems,
  handleArchiveTestcase,
  showArchived,
  handleCloneTestcase,
  setShowArchived,
  setShowConfirmationModal,
  handleModalShow,
  fetchTestCases,
  handleOpenExportModal,
  setShowArchiveWarning,
  handleBulkEditModal,
}) => {
  if (showArchived) {
    return (
      <Stack direction="row"spacing={1} alignItems="center">
        <MuiButton variant="contained" onClick={setShowArchived} title="Add new test case" size='large'>
          Show all
        </MuiButton>
        <MuiButton
          variant="outlined"
          size='large'
          color='secondary'
          onClick={() => handleArchiveTestcase('unarchived')}
          disabled={!isSelectedItems}
          title={
            !isSelectedItems
              ? 'Select test cases to perform this action'
              : 'Unarchive selected test cases'
          }>
          Unarchive
        </MuiButton>
        <MuiButton
          variant="outlined"
          size='large'
          color='secondary'
          onClick={() => setShowConfirmationModal(true)}
          disabled={true}
          title='This action has been disabled'
          // disabled={!isSelectedItems}
          // title={
          //   !isSelectedItems
          //     ? 'Select test cases to perform this action'
          //     : undefined
          // }
          >
          Delete
        </MuiButton>
      </Stack>
    );
  }
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <MuiButton variant="contained" onClick={handleOpenTestCaseModal} title="Add new test case" size='large'>
        + Add
      </MuiButton>
      <MuiButton
        variant="outlined"
        size='large'
        color='secondary'
        disabled={!isSelectedItems}
        onClick={() => {
          handleBulkEditModal(true);
        }}
        title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Bulk Edit'
        }>
        Bulk Edit
      </MuiButton>
      <MuiButton
        variant="outlined"
        size='large'
        color='secondary'
        disabled={!isSelectedItems}
        onClick={handleCloneTestcase}
        title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Clone'
        }>
        Clone
      </MuiButton>
      <MuiButton
        variant="outlined"
        size='large'
        color='secondary'
        onClick={setShowArchived}
        title="Click to show archived test cases">
        Show archived
      </MuiButton>
      <Dropdown>
        <Dropdown.Toggle variant="outline-secondary" id="more-dropdown">
          More
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => { setShowArchiveWarning(true) }} title={
            !isSelectedItems
              ? 'Select test cases to perform this action'
              : 'Archive test cases'
          } disabled={!isSelectedItems}>
            Archive
          </Dropdown.Item>
          <Dropdown.Item onClick={handleModalShow} title="Import from CSV">
            Import from CSV
          </Dropdown.Item>
          <Dropdown.Item onClick={handleOpenExportModal} title="Export to CSV">
            Export to CSV
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <IconButton
        onClick={fetchTestCases}
        title="Click to refresh the list"
        size="large"
        sx={{
          border: '1px solid #6c757d',
          color: '#6c757d',
          padding: '8px',
        }}
      >
        <Refresh />
      </IconButton>
    </Stack>
  );
};

export const SecondaryTabsTestCycles = ({
  handleOpenTestCycleModal,
  isSelectedItems,
  handleCloneTestcycle,
  setShowConfirmationModal,
  refreshData,
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <MuiButton
        variant="contained"
        size='large'
        title="Add new test cycle"
        onClick={handleOpenTestCycleModal}>
        + New Test Cycle
      </MuiButton>
      <MuiButton
        variant="outlined"
        size='large'
        color='secondary'
        disabled={isSelectedItems !== 1}
        onClick={handleCloneTestcycle}
        title={
          isSelectedItems === 1
            ? 'Clone'
            : 'Select one test cycle to perform this action'
        }>
        Clone
      </MuiButton>

      <MuiButton
        variant="outlined"
        size='large'
        color='secondary'
        disabled={!isSelectedItems}
        onClick={() => setShowConfirmationModal(true)}
        title={
          !isSelectedItems
            ? 'Select test cycles to perform this action'
            : 'Delete'
        }>
        Delete
      </MuiButton>
      <TableRefreshButton refreshData={refreshData} />
    </Stack>
  );
};

export const SecondaryTabsTestPlans = ({
  handleOpenTestPlanModal,
  isSelectedItems,
}) => {
  return (
    <Stack direction="horizontal" gap={2}>
      <Button
        variant="primary"
        title="Add new test plan"
        onClick={handleOpenTestPlanModal}>
        + New Test Plan
      </Button>

      <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        title={
          !isSelectedItems
            ? 'Select test plans to perform this action'
            : 'Delete test plan'
        }>
        Delete
      </Button>
    </Stack>
  );
};
